import { render } from "./WelcomeAfterSignUp.vue?vue&type=template&id=b8de2e80&scoped=true"
const script = {}

import "./WelcomeAfterSignUp.vue?vue&type=style&index=0&id=b8de2e80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8de2e80"]])

export default __exports__